<template>
  <div class="raisedHandIndicator">
    <svg
      aria-label="Asking"
      role="img"
      fill="#040404"
      height="16px"
      width="16px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.542 14.191a.748.748 0 0 1-.292.059"></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5 3.75a2.25 2.25 0 0 1 4.5 0v.128A2.25 2.25 0 0 1 18 6v.128a2.25 2.25 0 0 1 3 2.122v6.568a7.682 7.682 0 0 1-13.934 4.465l-4.62-6.468a2.388 2.388 0 0 1 3.779-2.917l1.275 1.53V6a2.25 2.25 0 0 1 3-2.122V3.75Zm1.042 10.441A.75.75 0 0 0 12 13.5V3.75a.75.75 0 0 1 1.5 0v9.75a.75.75 0 0 0 1.5 0V6a.75.75 0 0 1 1.5 0v7.5a.75.75 0 0 0 1.5 0V8.25a.75.75 0 0 1 1.5 0V14.818A6.182 6.182 0 0 1 8.287 18.41l-4.62-6.468a.888.888 0 0 1 1.405-1.085l2.602 3.122A.75.75 0 0 0 9 13.5V6a.75.75 0 0 1 1.5-.006V13.5a.75.75 0 0 0 .75.75"
      ></path>
    </svg>
  </div>
</template>
<style scoped>
.raisedHandIndicator {
  background-color: rgb(255, 214, 0);
  display: inline-block;
  border-radius: 4px;
  box-sizing: border-box;
}
</style>
